// Item classes - adapt to collapsed state
export const getSidebarItemClasses = (isCollapsed: boolean) => ({
    base: `flex items-center py-2 ${
      isCollapsed ? 'px-2 justify-center' : 'px-3'
    } text-gray-700 hover:bg-[#FAFAFA] transition-colors text-base font-semibold rounded-lg group relative`,
    active: "bg-[#FAFAFA] text-[#252B37]",
    icon: `w-5 h-5  text-gray-500 flex-shrink-0`,
    activeIcon: "text-[#252B37]",
    label: `text-base font-semibold ${
      isCollapsed ? 'sr-only' : 'block'
    } transition-opacity duration-200 max-[1200px]:sr-only`,
    tooltip: `absolute left-full ml-2 px-2 py-1 bg-gray-900 text-white text-sm rounded opacity-0 pointer-events-none group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap z-50 ${
      isCollapsed ? 'block' : 'hidden'
    }`,
  });

  export interface SidebarItem {
    type: SidebarItemType;
    icon?: string;
    label?: string;
    href?: string;
    isActive?: boolean;
    requiredPermissions?: string[];
  }

  // Types
export type SidebarItemType = 'link' | 'divider';